import { render, staticRenderFns } from "./pagePreview.vue?vue&type=template&id=c85eceee&"
import script from "./pagePreview.vue?vue&type=script&lang=ts&"
export * from "./pagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./pagePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports